import { render, staticRenderFns } from "./BaseTLModalDialogSimple.vue?vue&type=template&id=49b955a0&"
import script from "./BaseTLModalDialogSimple.vue?vue&type=script&lang=ts&"
export * from "./BaseTLModalDialogSimple.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports